<template>
  <div class="login-page">
    <el-card class="login-card">
      <template #header>
        <div class="login-title">后台管理员登录</div>
      </template>
      <el-form @submit.prevent="login">
        <el-form-item>
          <el-input v-model.trim="username" placeholder="后台账号" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="password" type="password" show-password placeholder="密码" />
        </el-form-item>
        <el-button type="primary" style="width: 100%" @click="login">登录</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { loginApi } from '../api/admin'
import { setToken } from '../utils/auth'

const router = useRouter()
const username = ref('admin')
const password = ref('123456')

async function login() {
  try {
    const data = await loginApi(username.value, password.value)
    setToken(data.token)
    router.replace('/overview')
  } catch (e) {
    ElMessage.error(e.message || '登录失败')
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e7effd 0%, #f5f7fb 45%, #eef2ff 100%);
}

.login-card {
  width: 420px;
}

.login-title {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
}
</style>
